import apiClient from './client';

export const subscriptionsAPI = {
  async getStatus() {
    const response = await apiClient.get('/subscriptions/status/');
    return response.data;
  },

  async checkSyncPermission() {
    const response = await apiClient.post('/subscriptions/sync_check/');
    return response.data;
  },

  async registerDevice(deviceData) {
    const response = await apiClient.post('/devices/register/', deviceData);
    return response.data;
  },

  async getDevices() {
    const response = await apiClient.get('/devices/');
    return response.data;
  },
};